import React from "react";
import { Typography } from "@mui/material";
import { Message } from "../../../type/chat.types";

type MessageTextProps = {
  message: Message;
  isMe: boolean;
  hasFile: boolean;
};

const MessageText = ({ isMe, hasFile, message }: MessageTextProps) => {
  return (
    <Typography
      variant="body1"
      fontSize={14}
      sx={{
        mr: isMe ? 1 : 0,
        ml: isMe ? 0 : 1,
        mb: hasFile ? 0.5 : 0,
        width: "100%",
        wordWrap: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "pre-wrap",
      }}
    >
      {message?.text}
    </Typography>
  );
};

export default MessageText;
